import type { TranslationSchema } from './ru';

export const uz: TranslationSchema = {
  common: {
    showPassword: 'Parolni ko‘rsatish',
    hidePassword: 'Parolni yashirish',
    currency: 'so‘m',
    loading: 'Yuklanmoqda…',
    retry: 'Qayta urinish',
    save: 'O‘zgarishlarni saqlash',
    cancel: 'Bekor qilish',
    confirm: 'Tasdiqlash',
    confirmDefault: 'Ishonchingiz komilmi?',
    close: 'Yopish',
    delete: 'O‘chirish',
    search: 'Qidiruv',
    all: 'Hammasi',
    export: 'Eksport',
    somethingWrong: 'Xatolik yuz berdi',
    notFound: 'Sahifa topilmadi',
    noAccess: 'Sizda bu bo‘limga ruxsat yo‘q',
    back: 'Orqaga',
    prev: 'Oldingi sahifa',
    next: 'Keyingi sahifa',
    comingSoon: 'Bo‘lim ishlab chiqilmoqda',
    comingSoonSubtitle: 'Tez orada bu bo‘lim shu yerda paydo bo‘ladi',
  },
  units: {
    piece: 'dona',
    kilogram: 'kg',
    meter: 'm',
    bag: 'qop',
    ton: 't',
    sheet: 'list',
    bucket: 'chelak',
    roll: 'rulon',
    box: 'quti',
    pack: 'pachka',
    liter: 'l',
  },
  brand: {
    name: 'Buildix',
    footer: '© 2026 Buildix · Strotech',
  },
  sync: {
    unpaired: "Do'kon kompyuteri bulutga bog'lanmagan — bu yerdagi ma'lumot yangilanmaydi.",
    unpairedShop: "Bu kompyuter bulutga bog'lanmagan — savdo ishlaydi, lekin egasi uni masofadan ko'ra olmaydi.",
    staleShop: "Bulutga {{age}} dan beri ma'lumot yuborilmadi — egasi masofadan eski raqamlarni ko'radi.",
    pushBroken: "Bulutga ma'lumot yuborilmayapti. Savdo ishlayveradi, lekin egasi masofadan eski raqamlarni ko'radi — qo'llab-quvvatlashga murojaat qiling.",
    pushBrokenCloud: "Do'kon aloqada, lekin ma'lumot kelmayapti — bu yerdagi raqamlar eskirgan. Qo'llab-quvvatlashga murojaat qiling.",
    stale: "Ma'lumot {{age}} oldin yangilangan — do'kon aloqada emas.",
    ageUnknown: 'anchadan',
    ageMinutes: '{{count}} daqiqa',
    ageHours: '{{count}} soat',
    ageDays: '{{count}} kun',
  },
  nav: {
    sections: {
      operations: 'Operatsiyalar',
      clients: 'Mijozlar',
      supply: 'Ta’minot',
      management: 'Boshqaruv',
    },
    dashboard: 'Panel',
    sales: 'Sotuvlar',
    cash: 'Kassa',
    warehouse: 'Ombor',
    products: 'Tovarlar va narxlar',
    categories: 'Kategoriyalar',
    returns: 'Qaytarishlar',
    debts: 'Qarzlar',
    customers: 'Mijozlar',
    purchases: 'Xarid',
    suppliers: 'Yetkazib beruvchilar',
    shifts: 'Smenalar',
    reports: 'Hisobotlar',
    employees: 'Xodimlar',
    audit: 'Audit',
    notifications: 'Bildirishnomalar',
    settings: 'Sozlamalar',
    account: 'Mening hisobim',
    logout: 'Chiqish',
    menu: 'Menyu',
    devices: 'Qurilmalar',
  },
  devices: {
    title: 'Qurilmalar',
    subtitle: 'Printer va skaner ulanishini tekshirish',
    printer: {
      connected: 'Ulangan printerlar',
      detect: 'Printerni aniqlash',
      usbFound: 'ulangan',
      usbHint: 'Brauzer o‘zi printerlarni ko‘rmaydi. «Printerni aniqlash» ni bosing va ochilgan ro‘yxatdan USB printeringizni tanlang.',
      usbUnsupported: 'Bu brauzer USB qurilmalarni ko‘rsata olmaydi (Chrome yoki Edge kerak). Sinov yorlig‘i baribir ishlaydi.',
      usbNone: 'Ulangan USB printer topilmadi yoki tanlanmadi.',
      lastCheck: 'Oxirgi tekshiruv: {{date}} {{time}}, {{size}} mm —',
      lastOk: 'ishladi',
      lastFailed: 'ishlamadi',
      goToLabels: 'Tovar yorliqlarini chiqarish',
      title: 'Yorliq printeri',
      subtitle: 'Brauzer tizimdagi printerlar ro‘yxatini ko‘ra olmaydi — shuning uchun eng ishonchli tekshiruv: haqiqiy sinov yorlig‘ini chop etish.',
      size: 'Yorliq o‘lchami',
      test: 'Sinov yorlig‘ini chop etish',
      askResult: 'Yorliq to‘g‘ri chiqdimi?',
      yes: 'Ha',
      no: 'Yo‘q',
      ok: 'Printer ulangan va ishlayapti.',
      popupBlocked: 'Brauzer yangi oynani bloklagan — chop etish oynasi ochilmadi. Manzil qatoridagi blok belgisidan buildix.uz ga ruxsat bering yoki faylni yuklab oling.',
      download: 'PDF ni yuklab olish',
      troubleTitle: 'Yorliq chiqmadi — quyidagilarni tekshiring:',
      trouble1: 'Printer yoqilganmi va USB/tarmoq kabeli ulanganmi',
      trouble2: 'Chop etish oynasida aynan yorliq printeri tanlanganmi (A4 emas)',
      trouble3: 'Qog‘oz o‘lchami printer sozlamasida yorliq o‘lchamiga teng qilinganmi',
      trouble4: 'Yorliq ruloni tugamaganmi va kalibrlash bajarilganmi',
    },
    scanner: {
      title: 'Shtrix-kod skaneri (pistolet yoki statsionar)',
      subtitle: 'Skaner klaviatura bo‘lib ulanadi, shuning uchun uni ro‘yxatdan topib bo‘lmaydi — lekin terish tezligidan aniq ajratsa bo‘ladi.',
      placeholder: 'Shu maydonga istalgan shtrix-kodni skanerlang…',
      detected: 'Skaner aniqlandi — tezlik odam terishidan ancha yuqori.',
      typed: 'Bu qo‘lda terilgan. Skaner ulangan bo‘lsa, kodni qayta skanerlang.',
      tooShort: 'Juda qisqa — baholash uchun kamida 6 ta belgi kerak.',
      noEnter: 'Skaner oxirida Enter yubormayapti. Uni sozlamalardan yoqing, aks holda kod savatga o‘zi qo‘shilmaydi.',
      code: 'Kod',
      chars: 'Belgilar',
      speed: 'O‘rtacha oraliq',
      ms: 'ms',
      checkInBase: 'Bazadan tekshirish',
      found: 'Topildi: {{name}}',
      notFound: 'Bu kod bazada yo‘q',
      hint: 'Tekshiruv hech narsani saqlamaydi. Kod bazada topilmasa — skaner to‘g‘ri ishlayapti, faqat tovarga bu kod biriktirilmagan.',
    },
  },
  notifications: {
    subtitle: 'O‘qilmaganlar: {{count}}',
    empty: 'Hammasi joyida — bildirishnoma yo‘q',
    liveHint: 'Ombor va qarz ogohlantirishlari avtomatik yangilanadi. Smena va yetkazib berish hodisalari sodir bo‘lgan zahoti keladi.',
    markAll: 'Hammasini o‘qilgan deb belgilash',
    viewAll: 'Hammasini ko‘rish',
    today: 'Bugun',
    yesterday: 'Kecha',
    cat: {
      warehouse: 'Ombor',
      debt: 'Qarzlar',
      shift: 'Smenalar',
      supply: 'Yetkazib berish',
    },
    withdrawRequest: 'Naqd yechish so‘rovi',
    debtOverdue: 'Qarz muddati o‘tgan',
    debtDueToday: 'Qarz to‘lash muddati — bugun',
    lowStock: 'Omborda kam qoldi',
    outOfStock: 'Tovar tugagan',
  },
  seller: {
    nav: {
      pos: 'Kassa',
      sales: 'Sotuvlarim',
      products: 'Tovarlar',
      clients: 'Mijozlar',
      debts: 'Qarzlar',
      supplies: 'Postavka',
      shifts: 'Smenalar',
      shiftOpen: 'Smena ochiq',
      shiftClosed: 'Smena yopiq',
      openShift: 'Smena ochish',
      hoursShort: 's',
      minsShort: 'd',
      account: 'Akkaunt',
      notifications: 'Bildirishnomalar',
    },
    products: {
      title: 'Tovarlar',
      subtitle: 'Do‘kon katalogi · kelish narxlari egasiga ko‘rinadi',
      cols: { location: 'JOY' },
      card: {
        price: 'Sotuv narxi',
        stock: 'Qoldiq',
        minStock: 'Min. qoldiq',
        sku: 'Artikul',
        barcode: 'Shtrix-kod',
        location: 'Ombordagi joyi',
        supplier: 'Yetkazib beruvchi',
        lastIn: 'Oxirgi kirim',
        soldMonth: 'Oyiga sotilgan',
        sell: 'Sotish — kassani ochish',
        costHidden: 'Kelish narxi va ustama faqat egaga ko‘rinadi',
      },
    },
    debts: {
      title: 'Mijozlar qarzi',
      subtitle: 'Qarz bo‘yicha to‘lov qabuli · to‘lov joriy smena kassasiga tushadi',
      acceptedToday: 'Bugun qabul qilingan',
      acceptedCols: { time: 'VAQT', customer: 'MIJOZ', method: 'USUL', remaining: 'QARZ QOLDIG‘I', amount: 'SUMMA' },
    },
    clients: {
      title: 'Mijozlar',
      subtitle: 'Do‘kon mijozlari bazasi · {{count}} ta yozuv',
      add: 'Yangi mijoz',
      addHint: 'Ism va telefon yetarli — qolganini keyinroq to‘ldirish mumkin.',
      searchPlaceholder: 'Ism yoki telefon bo‘yicha qidiruv…',
      empty: 'Mijozlar topilmadi',
      regular: 'doimiy',
      filters: { all: 'Hammasi', withDebt: 'Qarzli', regular: 'Doimiy' },
      purchasesCount: '{{count}} ta xarid',
      cols: { client: 'MIJOZ', phone: 'TELEFON', monthPurchases: 'OYIGA XARID', lastPurchase: 'OXIRGISI', debt: 'QARZ' },
      form: { name: 'Ism / nomi', phone: 'Telefon', type: 'Mijoz turi' },
    },
    supplies: {
      title: 'Postavka',
      subtitle: 'Administrator yaratadi · sizga ko‘rish va qabul qilish mumkin',
      readOnly: 'Ko‘rish — o‘zgartirish va qabul qilish administratorda',
      received: 'qabul qilingan',
      allTitle: 'Barcha postavkalar',
      accept: 'Qabulni boshlash',
      acceptOnArrival: 'Qabul yetib kelgach ochiladi',
      eta: 'yetib kelishi: {{date}}',
      positionsAmounts: '{{count}} pozitsiya · summalar egaga ko‘rinadi',
      filters: { all: 'Barchasi', awaiting: 'Kutilmoqda', accepted: 'Qabul qilingan' },
      cols: { positions: 'POZITSIYA' },
      state: { accepted: 'qabul qilingan', awaiting: 'qabul kutilmoqda', inTransit: 'yo‘lda', delayed: 'kechikmoqda' },
    },
    notifications: {
      subtitle: 'Faol bildirishnomalar: {{count}}',
      unread: 'O‘qilmagan',
      empty: 'Hammasi joyida — bildirishnoma yo‘q',
      liveHint: 'Ro‘yxat joriy holatni ko‘rsatadi: masala hal bo‘lishi bilan yozuv yo‘qoladi.',
      debtOverdue: 'Qarz muddati o‘tgan',
      debtDueToday: 'Qarz to‘lash muddati — bugun',
      lowStock: 'Omborda kam qoldi',
      outOfStock: 'Tovar tugagan',
    },
    pos: {
      allProducts: 'Barcha tovarlar',
      outOfStock: 'yo‘q',
      priceOnRequest: 'Narxni so‘rang',
      receipt: 'Chek',
      clear: 'Tozalash',
      discard: 'Chekni o‘chirish',
      discardConfirm: 'Yakunlanmagan chek o‘chirilsinmi? Tovarlar omborga qaytadi.',
      held: 'Kutayotgan cheklar',
      park: 'Keyinga qoldirish',
      leaveTitle: 'Savdo tugallanmagan',
      leaveMessage:
        'Chekni keyinga qoldirasizmi? U «Kutayotgan cheklar» ro‘yxatida saqlanadi va istalgan vaqtda davom ettirasiz.',
      stay: 'Kassada qolish',
      positions: 'Pozitsiya',
      checkoutTitle: 'To‘lov',
      toPay: 'To‘lanadi',
      received: 'Mijozdan olindi',
      noChange: 'Qaytimsiz',
      change: 'Qaytim',
      short: 'Yetmayapti',
      confirm: 'Sotuvni tasdiqlash',
      cardHint: 'Terminal orqali to‘lovni o‘tkazing va muvaffaqiyatli tranzaksiyadan so‘ng tasdiqlang.',
      debtNeedsCustomer: 'Qarzga sotish uchun bazadan mijoz tanlang',
      paidNow: 'Hozir to‘landi',
      debtRest: 'Qarzga (qoldiq)',
      doneTitle: 'Sotuv rasmiylashtirildi',
      print: 'Chekni chop etish',
      newSale: 'Yangi sotuv',
      thanks: 'Xaridingiz uchun rahmat!',
      shift: 'Smena',
      qty: 'Miqdor',
      qtyHint: 'Miqdorni yozing — kasr ham bo‘ladi (12; 3,5; 0,25)',
      editPrice: 'Narxni o‘zgartirish',
      openShift: 'Smenani ochish',
      loadMore: 'Yana ko‘rsatish',
      shownOf: '{{shown}} / {{total}} ta tovar',
      refineSearch: 'Juda ko‘p natija — qidiruvni aniqlashtiring',
      backToSearch: 'Qidiruvga qaytish',
      external: {
        button: 'Katalogda yo‘q',
        title: 'Katalogda yo‘q tovar',
        subtitle: 'Ombor qoldig‘iga ta’sir qilmaydi — faqat shu chekka qo‘shiladi',
        name: 'Tovar / xizmat nomi',
        price: 'Sotuv narxi',
        cost: 'Kelish narxi (ixtiyoriy)',
        costHint: 'Bo‘sh qoldirilsa, foyda hisobotida bu qator to‘liq foyda bo‘lib ko‘rinadi.',
        costTooHigh: 'Kelish narxi sotuv narxidan kichik bo‘lishi kerak.',
        add: 'Chekka qo‘shish',
      },
      askPrice: {
        title: 'Narxni kiriting',
        price: 'Sotuv narxi',
        add: 'Chekka qo‘shish',
        hint: 'Bu tovarning narxi sotuvchiga ko‘rsatilmaydi — narxni egasidan so‘rab kiriting.',
      },
    },
    shifts: {
      range: { week: 'Hafta', month: 'Oy', all: 'Butun davr' },
      total: 'Davr uchun jami',
    },
    sales: {
      returnsStat: 'Qaytarishlar',
      returnsSum: '· {{value}} so‘m',
      returnOf: '№{{number}} chek bo‘yicha qaytarish',
      returnHint: 'Qaytarish chek kartochkasi orqali rasmiylashtiriladi · oldingi smenalar tarixi «Mening smenalarim»da',
    },
  },
  auth: {
    title: 'Tizimga kirish',
    subtitle: 'Do‘kon egasi yoki administrator bergan ma’lumotlarni kiriting.',
    usernameLabel: 'Login',
    usernamePlaceholder: 'Loginni kiriting',
    passwordLabel: 'Parol',
    passwordPlaceholder: '••••••••',
    forgotPassword: 'Parolni unutdingizmi?',
    submit: 'Kirish',
    submitting: 'Kirilmoqda…',
    contactAdmin: 'ADMINISTRATOR BILAN ALOQA',
    errors: {
      invalidCredentials: 'Login yoki parol noto‘g‘ri',
      generic: 'Kirib bo‘lmadi. Qayta urinib ko‘ring.',
      consoleNotConfigured: 'Konsol sozlanmagan — server administratoriga murojaat qiling.',
      marketMissing: 'Bu nusxada do’kon topilmadi. Qo’llab-quvvatlashga murojaat qiling.',
      tooManyAttempts: 'Juda ko‘p urinish. Keyinroq urinib ko‘ring.',
    },
  },
  subscription: {
    expiredTitle: 'Obuna muddati tugadi',
    expiredDesc: 'Do‘kon obunasi muddati tugagan. Uzaytirish uchun administrator bilan bog‘laning.',
    blockedTitle: 'Do‘kon bloklangan',
    blockedDesc: 'Do‘konga kirish vaqtincha to‘xtatilgan. Administrator bilan bog‘laning.',
  },
  categories: {
    title: 'Kategoriyalar',
    subtitle: 'Yo‘nalishlar va ular bo‘yicha savdo',
    add: 'Qo‘shish',
    edit: 'Tahrirlash',
    newPlaceholder: 'Yangi kategoriya nomi…',
    empty: 'Kategoriya yo‘q. Birinchisini yuqoridan qo‘shing.',
    uncategorized: 'Kategoriyasiz',
    deleteTitle: 'Kategoriyani o‘chirish',
    deleteHint: '«{{name}}» o‘chiriladi. Undagi {{count}} ta tovar YO‘QOLMAYDI — ular kategoriyasiz qoladi.',
    profitNote: 'Davr bo‘yicha jami foyda: {{value}}',
    stats: { count: 'Kategoriyalar', products: 'Tovarlar', sales: 'Savdo' },
    cols: { name: 'KATEGORIYA', products: 'TOVARLAR', sales: 'SAVDO', share: 'ULUSH' },
    addPlaceholder: 'Kategoriya nomi…',
    deleteConfirm: '«{{name}}» kategoriya o‘chirilsinmi?',
  },
  warehouse: {
    title: 'Ombor',
    subtitle: '{{count}} pozitsiya · qoldiq qiymati {{value}} so‘m',
    subtitleShort: '{{count}} pozitsiya · kam: {{low}} · tugagan: {{out}}',
    addProduct: 'Tovar qo‘shish',
    newPurchase: 'Xarid rasmiylashtirish',
    stocktake: 'Inventarizatsiya',
    searchPlaceholder: 'Nomi, artikuli yoki shtrix-kodi bo‘yicha qidiruv…',
    onlyLow: 'Faqat tugayotganlar',
    allCategories: 'Hammasi',
    showing: '{{total}} tadan {{shown}} tasi ko‘rsatildi',
    empty: 'Tovarlar topilmadi',
    movementHint: 'Min. qoldiq jadvalda to‘g‘ridan-to‘g‘ri o‘zgaradi. Qatorni bosing — tovar harakati va tuzatish.',
    filter: { all: 'Hammasi', ok: 'Normada', low: 'Kam', out: 'Yo‘q' },
    movement: {
      title: 'Tovar harakati',
      empty: 'Harakatlar hali yo‘q',
      correctionTitle: 'Tuzatish (inventarizatsiya)',
      correctionHint: 'Farq harakatga tuzatish sifatida yoziladi va jurnalga tushadi',
      actualQty: 'Haqiqiy qoldiq',
      apply: 'Qo‘llash',
      type: {
        initialStock: 'Boshlang‘ich qoldiq',
        purchase: 'Kirim',
        sale: 'Sotuv',
        saleReversal: 'Sotuv qaytarilishi',
        correction: 'Tuzatish',
      },
    },
    stats: {
      positions: 'Jami pozitsiya',
      value: 'Qoldiq qiymati',
      low: 'Kam qolgan',
      out: 'Tugagan',
    },
    cols: {
      product: 'TOVAR',
      sku: 'ARTIKUL',
      category: 'KATEGORIYA',
      stock: 'QOLDIQ',
      minStock: 'MIN. QOLDIQ',
      cost: 'KELISH NARXI',
      price: 'SOTUV NARXI',
      status: 'HOLAT',
      lastReceipt: 'OXIRGI KIRIM',
    },
    status: {
      inStock: 'Mavjud',
      low: 'Kam',
      out: 'Yo‘q',
    },
    form: {
      addTitle: 'Yangi tovar',
      editTitle: 'Tovarni tahrirlash',
      name: 'Nomi',
      sku: 'Artikul',
      barcode: 'Shtrix-kod',
      barcodeHint: 'Skanerlang, tizim yaratsin yoki o‘z raqamingizni yozing («1», «15»).',
      barcodeShop: 'Do‘kon kodi — yorliqda shu ko‘rinishda bosiladi.',
      barcodePlaceholder: 'Skanerlang yoki yarating',
      barcodeGenerate: 'Yaratish',
      barcodeRegenerate: 'Yangilash',
      barcodeReplaceConfirm:
        'Kod almashtirilsinmi? Eski kod bilan chop etilgan yorliqlar ishlamay qoladi.',
      barcodeInternal: 'Do‘kon kodi — yorliqni o‘zimiz chop etamiz.',
      barcodeFactory: 'Zavod kodi — yorliq tovarda allaqachon bor.',
      category: 'Kategoriya',
      unit: 'O‘lchov',
      salePrice: 'Sotuv narxi',
      minSalePrice: 'Min. sotuv narxi',
      costPrice: 'Kelish narxi',
      quantity: 'Qoldiq',
      minThreshold: 'Min. qoldiq',
      hidePrice: 'Narxni sotuvchidan yashirish',
      description: 'Tavsif',
      descriptionHint: 'Sotuvchiga tovar kartochkasida ko‘rinadi',
      noCategory: 'Kategoriyasiz',
      delete: 'O‘chirish',
      deleteConfirm: 'Bu tovar o‘chirilsinmi?',
      belowCost: 'Sotuv narxi kelish narxidan past',
    },
    stocktakeModal: {
      title: 'Inventarizatsiya',
      subtitle: 'Haqiqiy qoldiqlarni kiriting — farqlar qayd etiladi',
      searchPlaceholder: 'Tovar qidirish…',
      system: 'Tizim',
      counted: 'Haqiqiy',
      variance: 'Farq',
      submit: 'Inventarizatsiyani o‘tkazish',
      resultTitle: 'Inventarizatsiya tugadi',
      adjusted: 'Tuzatilgan pozitsiyalar: {{count}}',
      noChanges: 'Farqlar topilmadi',
      done: 'Tayyor',
    },
  },
  products: {
    title: 'Tovarlar va narxlar',
    subtitle: 'Sotuv narxi jadvalda to‘g‘ridan-to‘g‘ri o‘zgaradi',
    catalogCount: '{{count}} tovar · yashirilgan: {{hidden}}',
    margin: 'MARJA',
    hidden: 'Yashirilgan',
    hide: 'Yashirish',
    show: 'Ko‘rsatish',
    hiddenNote: 'Yashirilgan tovar kassada sotuvchiga ko‘rinmaydi, lekin hisobot va tarixda qoladi. Kelish narxi oxirgi xariddan avtomatik yangilanadi.',
  },
  cash: {
    title: 'Kassa · naqd',
    subtitle: 'kun davomidagi barcha naqd harakatlari',
    shiftOpen: '№{{n}} smena ochiq',
    openingWas: 'ochilishda {{value}} bor edi',
    balance: 'Hozir kassada',
    incomeToday: 'Kunlik kirim',
    expenseToday: 'Kunlik chiqim',
    opsCount: '{{count}} ta operatsiya',
    empty: 'Kun davomida harakat yo‘q',
    hint: 'Sotuv va qarz to‘lovlari bu yerga avtomatik tushadi. Chiqim, bankka topshirish va maydalash uchun naqd kiritish qo‘lda qo‘shiladi. Kassa qoldig‘i smena yopilganda solishtiriladi.',
    filter: { all: 'Hammasi', income: 'Kirim', expense: 'Chiqim' },
    cols: { time: 'VAQT', type: 'TUR', description: 'TAVSIF', who: 'KIM', amount: 'SUMMA' },
    type: {
      opening: 'Ochilish',
      sale: 'Sotuv',
      debtPayment: 'Qarz to‘lovi',
      deposit: 'Kiritish',
      expense: 'Chiqim',
      collection: 'Inkassatsiya',
      externalPurchase: 'Qo‘shni do‘kon',
    },
    desc: { receipt: 'Chek Ч-{{n}}' },
    category: {
      household: 'Xo‘jalik',
      delivery: 'Yetkazish',
      advance: 'Xodimga avans',
      other: 'Boshqa',
    },
    newOp: {
      button: 'Yangi operatsiya',
      title: 'Yangi operatsiya',
      category: 'Chiqim kategoriyasi',
      amount: 'Summa',
      comment: 'Izoh',
      commentHint: 'Masalan: suv, paketlar',
      available: 'Kassada mavjud: {{value}} so‘m',
      overdraft: 'Summa kassadagi qoldiqdan katta',
      confirm: 'O‘tkazish',
    },
  },
  returns: {
    title: 'Qaytarishlar',
    subtitle: 'oyiga: {{count}} ta qaytarish, {{sum}} so‘m · tushumning {{pct}}%',
    create: 'Qaytarish rasmiylashtirish',
    searchPlaceholder: 'Qaytarish, chek raqami yoki tovar…',
    empty: 'Qaytarishlar hali yo‘q',
    hint: 'Qaytarishda tovar avtomatik omborga qaytadi, summa tushumdan ayriladi, yozuv jurnalga tushadi.',
    cols: { return: 'QAYTARISH', receipt: 'CHEK', items: 'TOVARLAR', reason: 'SABAB', money: 'PUL', sum: 'SUMMA' },
    reason: { defect: 'Brak', notFit: 'To‘g‘ri kelmadi', sellerError: 'Sotuvchi xatosi', other: 'Boshqa' },
    refund: { cash: 'Naqd', card: 'Kartaga', transfer: 'O‘tkazma' },
    findReceipt: 'Chekni toping',
    findPlaceholder: 'Chek raqami…',
    changeReceipt: 'Boshqa chek',
    sold: 'sotilgan: {{qty}}',
    refundMethod: 'Pulni qaytarish',
    refundMoney: 'Qaytariladi',
  },
  sales: {
    title: 'Sotuvlar',
    newSale: 'Yangi sotuv',
    searchPlaceholder: 'Chek, tovar yoki mijoz bo‘yicha qidiruv…',
    showing: '{{total}} tadan {{shown}} tasi',
    empty: 'Sotuvlar topilmadi',
    walkIn: 'Chakana',
    allSellers: 'Barcha sotuvchilar',
    stats: {
      sum: 'Sotuvlar summasi',
      checks: 'Cheklar',
      avg: 'O‘rtacha chek',
      debt: 'Qarzga',
      today: 'bugun',
    },
    period: { shift: 'Smena', today: 'Bugun', yesterday: 'Kecha', all: 'Hammasi', week: 'Hafta', month: 'Oy' },
    payment: {
      all: 'Hammasi',
      cash: 'Naqd',
      card: 'Karta',
      debt: 'Qarzga',
      terminal: 'Terminal',
      transfer: 'O‘tkazma',
      click: 'Click',
      mixed: 'Aralash',
      credit: 'Avans',
      returned: 'Qaytarilgan',
      returns: 'Qaytarishlar',
    },
    cols: {
      number: 'CHEK №',
      time: 'VAQT',
      seller: 'SOTUVCHI',
      items: 'TOVARLAR',
      customer: 'MIJOZ',
      pay: 'TO‘LOV',
      sum: 'SUMMA',
    },
    detail: {
      title: 'Chek',
      customer: 'Mijoz',
      status: 'Holat',
      qty: 'MIQDOR',
      price: 'NARX',
      subtotal: 'Chegirmasiz summa',
      paid: 'To‘langan',
      remaining: 'Qoldiq',
      payments: 'To‘lovlar',
      noPayments: 'To‘lovlar yo‘q',
      noItems: 'Pozitsiyalar yo‘q',
      invoice: 'Fakturani yuklab olish',
      cancel: 'Chekni bekor qilish',
      cancelConfirm: '№{{number}} chek bekor qilinsinmi? Tovarlar omborga, naqd kassadan qaytadi.',
      return: 'Tovarni qaytarish',
      returnConfirm: 'Qaytarishni tasdiqlash',
    },
    status: {
      draft: 'Qoralama',
      paid: 'To‘langan',
      debt: 'Qarzga',
      partial: 'Qisman',
      closed: 'Qarz yopilgan',
      cancelled: 'Bekor qilingan',
      returned: 'Qaytarilgan',
    },
  },
  debts: {
    title: 'Qarzlar',
    subtitle: '{{count}} mijoz · umumiy qarz {{value}} so‘m',
    subtitleChecks: '{{clients}} mijozda {{debts}} qarz · jami: {{value}} so‘m · muddati o‘tgan: {{overdue}} so‘m',
    searchPlaceholder: 'Mijoz, telefon yoki chek raqami…',
    empty: 'Qarzlar yo‘q',
    noDue: 'Muddatsiz',
    overdueTag: 'muddati o‘tgan',
    multi: 'qarzlar: {{count}}',
    multiTitle: 'Mijozda bir nechta qarz bor',
    paidOf: '{{total}} dan {{paid}} to‘langan',
    checkFor: 'chek {{total}}',
    perCheckHint: 'Har bir qarz — alohida chek, o‘z muddati va qoldig‘i bilan. To‘lov aniq chek bo‘yicha qabul qilinadi, shuning uchun hisob-kitoblar aralashmaydi.',
    filters: { all: 'Hammasi', overdue: 'Muddati o‘tgan', today: 'Bugun', upcoming: 'Kutilayotgan' },
    stats: {
      total: 'Umumiy qarz',
      overdue: 'Muddati o‘tgan',
      paidToday: 'Bugungi to‘lovlar',
      paidMonth: 'Shu oyda so‘ndirilgan',
    },
    cols: { customer: 'MIJOZ', phone: 'TELEFON', debts: 'QARZLAR', due: 'MUDDAT', sum: 'SUMMA', check: 'CHEK', items: 'TOVARLAR', remaining: 'QARZ QOLDIG‘I' },
    type: { individual: 'Jismoniy', legal: 'Yuridik' },
    pay: 'To‘lovni qabul qilish',
    payTitle: 'To‘lovni qabul qilish',
    payAmount: 'To‘lov summasi',
    payMethod: 'To‘lov usuli',
    payFull: 'To‘liq qarz',
    moreDebts: 'Mijozda yana {{count}} ta qarz bor — jami {{total}} so‘m — to‘lov eng eski chekdan yopiladi.',
    remaining: 'Qarz qoldig‘i',
    methods: { cash: 'Naqd', card: 'Karta', transfer: 'O‘tkazma', click: 'Click' },
    dueDate: 'Qaytarish muddati',
    setDueDate: 'Muddat belgilash',
    check: {
      title: '{{name}} · {{check}} bo‘yicha qarz',
      sold: 'Sotilgan',
      hasOthers: 'Mijozda yana qarzlar bor: {{count}} — ular alohida hisoblanadi',
      cols: { product: 'TOVAR', qty: 'SONI', price: 'NARX', sum: 'SUMMA' },
      noItems: 'Pozitsiyalar yo‘q',
      checkTotal: 'Chek',
      paid: 'To‘langan',
      payThis: 'Shu chek bo‘yicha to‘lovni qabul qilish',
      afterPay: 'To‘lovdan keyin qoladi',
      settled: 'chek yopiladi',
    },
  },
  purchases: {
    title: 'Xarid',
    subtitle: 'Yetkazib berishlar va yetkazuvchilarga buyurtmalar',
    newPurchase: 'Yangi xarid',
    empty: 'Xaridlar yo‘q',
    searchPlaceholder: 'Raqam, yetkazuvchi yoki tovar…',
    deleteConfirm: '№{{number}} xaridni o‘chirasizmi? Uning kirimi bekor qilinadi.',
    stats: {
      count: 'Oylik xaridlar',
      sum: 'Oylik summa',
      supplierDebt: 'Yetkazuvchilarga qarz',
      suppliers: 'Yetkazuvchilar',
    },
    cols: { number: '№', supplier: 'YETKAZUVCHI', items: 'TOVARLAR', date: 'SANA', sum: 'SUMMA', status: 'HOLAT' },
    status: { unpaid: 'To‘lanmagan', partial: 'Qisman', paid: 'To‘langan' },
    reorder: {
      title: 'Buyurtma tavsiyasi',
      positions: '{{count}} pozitsiya',
      empty: 'Hammasi yetarli',
      perDay: '{{qty}} {{unit}}/kun',
      daysLeft: '{{qty}} {{unit}} qoldi · {{days}} kunga',
      outOfStock: 'Tugagan',
      order: 'Buyurtma',
    },
    topSuppliers: 'Top yetkazuvchilar',
    manageSuppliers: 'Boshqarish',
    noSupplier: 'Yetkazuvchisiz',
    itemsCount: '{{count}} tovar',
    newModal: {
      title: 'Yangi kirim',
      subtitle: 'Omborga tovar kirimi',
      invoice: 'Nakladnoy №',
      addItems: 'Tovar qo‘shish',
      quickAdd: 'Tugayapti — tez qo‘shish',
      empty: 'Tovarni toping va kirimga qo‘shing',
      paidNow: 'Hozir to‘landi',
      payFull: 'To‘liq summa',
      debtRest: 'Qarz qoladi',
      payMethod: 'To‘lov usuli',
      payMethods: { cash: 'Naqd', transfer: 'O‘tkazma' },
      expectedDate: 'Yetib kelish sanasi',
      comment: 'Izoh (ixtiyoriy)',
      submit: 'Kirimni rasmiylashtirish',
      inTransit: 'Tovar hali yo‘lda',
      inTransitHint: 'Postavka qabul qilinmaguncha ombor to‘lmaydi',
    },
    delivery: { all: 'Hammasi', inTransit: 'Yo‘lda', accepted: 'Qabul qilingan' },
    detail: {
      title: 'Kirim',
      paid: 'To‘langan',
      outstanding: 'Qolgan qarz',
      payTitle: 'Yetkazuvchiga to‘lash',
      pay: 'To‘lash',
      delivery: 'Postavka',
      accept: 'Qabul qilingan deb belgilash',
      payFullDebt: 'Butun qarz',
      inTransitHint: 'Tovar hali yo‘lda. Qabul qilingach ombor qoldiqlari to‘ldiriladi.',
    },
  },
  suppliers: {
    title: 'Yetkazib beruvchilar',
    subtitle: 'Yetkazib beruvchilar ma’lumotnomasi va ularning qarzlari',
    subtitleDebt: '{{count}} yetkazuvchi · yetkazuvchilarga qarz: {{debt}} so‘m',
    add: 'Yetkazuvchi qo‘shish',
    empty: 'Yetkazib beruvchilar yo‘q',
    searchPlaceholder: 'Yetkazuvchi qidirish…',
    cols: { name: 'YETKAZUVCHI', phone: 'TELEFON', debt: 'QARZ', receipts: 'KIRIMLAR' },
    debtLabel: 'Yetkazuvchiga qarz',
    noDebt: 'qarz yo‘q',
    weOwe: 'biz qarzdormiz',
    payDebt: 'Qarzni yopish',
    fifoHint: 'To‘lov eng eski xariddan boshlab qarzni yopadi (FIFO).',
    recentReceipts: 'So‘nggi xaridlar',
    deleteConfirm: '«{{name}}» yetkazuvchi o‘chirilsinmi?',
    deleteBlocked: 'O‘chirib bo‘lmaydi: {{count}} kirim, {{debt}} so‘m qarz.',
    form: {
      addTitle: 'Yangi yetkazuvchi',
      editTitle: 'Yetkazuvchini tahrirlash',
      name: 'Nomi',
      phone: 'Telefon',
      contact: 'Aloqa shaxsi',
      deliveryTerm: 'Yetkazish muddati',
      address: 'Manzil',
      comment: 'Izoh',
    },
  },
  customers: {
    title: 'Mijozlar',
    subtitle: 'Mijozlar bazasi · {{count}} ta yozuv',
    add: 'Yangi mijoz',
    empty: 'Mijozlar topilmadi',
    searchPlaceholder: 'Ism yoki telefon bo‘yicha qidiruv…',
    cols: { name: 'MIJOZ', phone: 'TELEFON', debt: 'QARZ', type: 'TUR', purchases: 'XARIDLAR', totalBought: 'JAMI OLGAN' },
    filters: { all: 'Hammasi', withDebt: 'Qarzli', legal: 'Tashkilotlar' },
    types: { individual: 'Chakana', legal: 'Yur. shaxs' },
    lastBuy: 'oxirgi xarid: {{date}}',
    noBuys: 'hali xarid yo‘q',
    deleteConfirm: '«{{name}}» mijoz o‘chirilsinmi?',
    deleteBlocked: 'O‘chirib bo‘lmaydi: {{debts}} ta qarz, {{debt}} so‘m.',
    form: {
      addTitle: 'Yangi mijoz',
      editTitle: 'Mijozni tahrirlash',
      name: 'Ism / nomi',
      phone: 'Telefon',
      type: 'Mijoz turi',
      debtLimit: 'Qarz limiti',
      noLimit: 'Limitsiz',
      initialDebt: 'Boshlang‘ich qarz',
      regular: 'Doimiy mijoz',
      regularHint: 'Cheklov yoqilganda qarzga ololadi',
      comment: 'Izoh',
    },
    detail: {
      title: 'Mijoz',
      totalDebt: 'Joriy qarz',
      debts: 'Qarzlar',
      noDebts: 'Qarzlar yo‘q',
      recentPurchases: 'Oxirgi xaridlar',
      noPurchases: 'Hali xaridlar yo‘q',
      allSales: 'Mijozning barcha sotuvlari',
      acceptDebt: 'Qarz to‘lovini qabul qilish',
      due: '{{date}} gacha',
      status: { open: 'Ochiq', closed: 'Yopiq' },
    },
  },
  shifts: {
    title: 'Smenalar',
    subtitle: 'Kassa smenalari va naqd nazorati',
    subtitleLive: 'hozir ochiq: {{open}} · haftada: {{count}} smena · kassa farqi: {{diff}} so‘m',
    openShift: 'Smenani ochish',
    closeShift: 'Smenani yopish',
    open: 'Ochiq',
    closed: 'Yopiq',
    currentShift: 'Joriy smena',
    cashier: 'Kassir',
    noOpenShift: 'Smena yopiq',
    metrics: {
      opening: 'Boshlang‘ich naqd',
      cashIn: 'Smenada naqd',
      cardIn: 'Smenada karta',
      terminal: 'Terminal',
      click: 'Click',
      withdrawals: 'Yechishlar',
      expected: 'Kassada bo‘lishi kerak',
    },
    history: 'Smenalar tarixi',
    cols: { date: 'SANA', cashier: 'KASSIR', period: 'DAVR', checks: 'CHEKLAR', revenue: 'TUSHUM', discrepancy: 'FARQ', status: 'HOLAT' },
    status: { open: 'Ochiq', balanced: 'Mos keldi', discrepancy: 'Farq bor' },
    empty: 'Hozircha smenalar yo‘q',
    tabs: { journal: 'Smenalar jurnali', attendance: 'Davomat' },
    filter: { all: 'Barchasi', open: 'Ochiq', discrepancy: 'Farq bilan' },
    tender: { cash: 'Naqd', card: 'Karta', debt: 'Qarzga', returns: 'Qaytarishlar' },
    detail: {
      title: 'Smena',
      checks: '{{count}} chek',
      revenueByTender: 'To‘lov turlari bo‘yicha tushum',
      totalRevenue: 'Jami tushum',
      cashRecon: 'Yopishda naqd sverkasi',
      externalPayouts: 'Qo‘shni do‘konga berildi',
      expectedCash: 'Kassada kutilgan',
      countedCash: 'Sotuvchi sanagan',
      discrepancy: 'Farq',
      notClosed: 'Smena hali ochiq — sverka yopilgandan so‘ng ko‘rinadi.',
    },
    attendance: {
      title: 'Davomat',
      scheduleHint: 'grafik: {{from}}–{{to}} · shu kunga reja: {{plan}} soat',
      range: { week: 'Hafta', month: 'Oy' },
      cols: { employee: 'XODIM', shifts: 'SMEN', days: 'KUN', hours: 'SOAT', avg: 'O‘RT. SMENA', late: 'KECHIKISH', plan: 'REJA BAJARILISHI' },
      hoursValue: '{{value}} soat',
      noLate: 'yo‘q',
      lateTimes: '{{count}} marta',
      empty: 'Davr uchun maʼlumot yo‘q',
    },
    withdraw: {
      action: 'Naqd yechish',
      request: 'Yechish so‘rovi',
      amount: 'Summa',
      comment: 'Izoh (ixtiyoriy)',
      submitRequest: 'So‘rov yuborish',
      submitWithdraw: 'Yechish',
      pendingTitle: 'Yechish so‘rovlari',
      noPending: 'Kutilayotgan so‘rovlar yo‘q',
      approve: 'Tasdiqlash',
      reject: 'Rad etish',
      from: '{{name}}dan',
      status: { pending: 'Kutilmoqda', approved: 'Tasdiqlangan', rejected: 'Rad etilgan', notRequired: 'Yechish' },
    },
    close: {
      title: 'Smenani yopish',
      expected: 'Kassada bo‘lishi kerak',
      counted: 'Haqiqiy summa',
      discrepancy: 'Farq',
      confirm: 'Smenani yopish',
    },
    forceClose: {
      action: 'Yopish',
      title: 'Smenani majburiy yopish · {{name}}',
    },
    rules: {
      title: 'Smena qoidalari',
      r1: 'Sotuv faqat ochiq smenada mumkin',
      r2: 'Naqd yechish — egasi tasdig‘i bilan',
      r3: 'Yopishda kassir haqiqiy summani kiritadi',
      r4: 'Farq qayd etiladi va egasiga ko‘rinadi',
    },
  },
  desktop: {
    title: 'Do‘kon dasturi',
    subtitle: 'Internetsiz ham ishlaydigan kassa — do‘kon kompyuteriga o‘rnatiladi',
    step1: 'Faylni yuklab olib, do‘kon kompyuterida ishga tushiring.',
    step2: 'Dastur ochilganda quyidagi manzilni kiriting va do‘kon EGASINING login-parolini yozing.',
    step3: 'Shundan keyin kassirlar o‘z login-paroli bilan kiraveradi.',
    urlLabel: 'Dasturga kiritiladigan manzil',
    download: 'Yuklab olish (Windows)',
    version: 'versiya {{version}}',
    notReady: 'Dastur hali yuklashga tayyor emas. Qo‘llab-quvvatlash xizmatiga murojaat qiling.',
  },

  settings: {
    title: 'Sozlamalar',
    subtitle: 'Do‘kon, kassa va tizim parametrlari',
    saved: 'O‘zgarishlar saqlandi',
    language: {
      title: 'Interfeys tili',
      hint: 'Darhol qo‘llanadi va hisobingizda saqlanadi',
      saveError: 'Til saqlanmadi — qayta urinib ko‘ring',
    },
    store: {
      title: 'Do‘kon',
      phone: 'Telefon',
      address: 'Manzil',
    },
    cash: {
      title: 'Kassa va smenalar',
      onlyShift: 'Sotuv faqat ochiq smenada',
      onlyShiftHint: 'Kassir birinchi sotuvdan oldin smena ochishi shart',
      approval: 'Naqd yechish — egasi tasdig‘i bilan',
      approvalHint: 'Administrator so‘rov yuboradi, siz tasdiqlaysiz',
      debtRegulars: 'Qarzga sotuv — faqat doimiy mijozlarga',
      debtRegularsHint: 'Qarz faqat bazadagi mijozga rasmiylashtiriladi',
      debtLimit: 'Bitta mijozga qarz limiti',
      debtLimitHint: 'Limitdan ortiq qarzga sotuv bloklanadi',
      discrepancy: 'Ruxsat etilgan kassa farqi',
    },
    attendance: {
      title: 'Davomat va grafik',
      hint: 'Do‘kon ish grafigi — «Davomat» tabida soat va kechikishlar shu asosda hisoblanadi.',
      start: 'Kun boshi',
      end: 'Kun oxiri',
      late: 'Kechikish chegarasi',
    },
    stock: {
      belowCost: 'Kelish narxidan past sotishni taqiqlash',
      belowCostHint: 'Kassir zararga sotolmaydi',
    },
    receipt: {
      title: 'Chek',
      subtitle: 'Rulon o’lchami va chop etish',
      width: 'Rulon eni',
      widthHint: 'Printerdagi qog’oz bilan mos bo’lishi shart — aks holda chek sig’maydi va har bir harf alohida qatorga tushadi.',
      mm: 'mm',
      autoPrint: 'Chek avtomatik chop etilsin',
      autoPrintHint: 'Savdo yopilishi bilan, chop etish oynasisiz.',
      header: 'Chek tepasidagi matn',
      footer: 'Chek pastidagi matn',
    },
    label: {
      title: 'Yorliq',
      subtitle: 'Tovar etiketkasi ruloni',
      width: 'Rulon eni',
      height: 'Yorliq bo’yi',
      sizeHint: 'Rulondagi bitta yorliqning o’lchami. Chop etishda shu ishlatiladi.',
      gap: 'Tirqish',
      gapHint: 'Ikki yorliq orasidagi bo’sh joy. Deyarli har doim 2 mm.',
      offset: 'Vertikal siljish',
      offsetHint:
        'Maket tepadan pastga shuncha suriladi. Sinov yorlig’ining ramkasi tepaga surilgan bo’lsa — farqni o’lchab shu yerga kiriting.',
      calibrate: 'Kalibrovka',
      test: 'Sinov yorlig’i',
      toolsHint:
        'Rulon almashtirilganda AVVAL «Kalibrovka» bosing — printer yorliq uzunligini o’zi o’lchaydi (bir-ikki yorliq bo’sh chiqadi, bu normal). So’ng «Sinov yorlig’i» bilan tekshiring: ramka yorliqqa teng tushsa o’lcham to’g’ri. Ikkalasi ham ekrandagi qiymat bilan ishlaydi, saqlash shart emas.',
      needDesktop: 'Yorliq printeriga faqat do’kon dasturi ichidan yuborish mumkin.',
      failed: 'Yorliq printeriga yuborib bo’lmadi.',
    },
    notify: {
      title: 'Bildirishnomalar',
      subtitle: 'Egaga Telegram’da nima yuborilsin',
      daySummary: 'Smena yopilganda kun yakuni',
      overdue: 'Muddati o‘tgan qarzlar',
      withdrawals: 'Naqd yechish so‘rovlari',
      telegramHint: 'Telegram «Аккаунт» bo‘limida ulanadi — har bir xodim o‘z Telegram ID sini saqlaydi.',
    },
    system: {
      title: 'Tizim',
      subtitle: 'Do‘kon tili, xavfsizlik va audit',
      defaultLanguage: 'Do‘konning standart tili',
      defaultLanguageHint: 'Yangi xodimlar uchun; har kimning o‘z tili bor',
      inactivityLogout: 'Harakatsizlikda avto-chiqish',
      inactivityLogoutHint: '0 — avtomatik chiqmaydi',
      minutes: 'daq',
      audit: 'Audit jurnali',
      auditHint: 'Xodimlar amallarini yozib borish',
    },
    terminals: {
      title: 'Bulutga bog‘langan kompyuter',
      subtitle: 'Do‘kon bazasi turgan kassa. Bittadan ortiq bo‘lmaydi',
      none: 'Hozircha hech qanday kompyuter bog‘lanmagan.',
      pairedAt: 'Bog‘langan',
      lastSeen: 'Oxirgi aloqa',
      never: 'aloqaga chiqmagan',
      revoked: 'Bekor qilingan',
      revoke: 'Bekor qilish',
      confirmTitle: 'Kompyuterni bulutdan uzish',
      confirmBody:
        '«{{name}}» bulutdan uziladi va bu qaytarilmaydi — yangi bog‘lash kerak bo‘ladi. Unda hali yuborilmagan savdolar qolgan bo‘lishi mumkin: uzilgandan keyin ular jo‘natilmaydi. Eski kompyuter bilan ishingiz tugagan bo‘lsagina davom eting.',
      hint: '2-kassani bu yerga qo‘shish shart emas — u server kassaga lokal tarmoq orqali ulanadi.',
    },
  },
  employees: {
    title: 'Xodimlar',
    subtitle: '{{count}} xodim · bugun {{active}} faol',
    add: 'Xodim qo‘shish',
    searchPlaceholder: 'Ism yoki login bo‘yicha qidiruv…',
    empty: 'Xodimlar topilmadi',
    online: 'Hozir tizimda',
    lastSeen: '{{time}} oldin edi',
    never: 'kirmagan',
    block: 'Bloklash',
    unblock: 'Blokdan chiqarish',
    blocked: 'Bloklangan',
    active: 'Faol',
    protected: 'Egasi va super-admin alohida sozlanadi',
    editTitle: 'Xodimni tahrirlash',
    deleteTitle: 'O‘chirish',
    deleteConfirm: '«{{name}}» xodim o‘chirilsinmi?',
    resetPassword: 'Parolni tiklash',
    resetPasswordHint: 'O‘zgartirmaslik uchun bo‘sh qoldiring',
    periodLabel: 'Natijalar davri:',
    period: { today: 'Bugun', week: 'Hafta', month: 'Oy', year: 'Yil' },
    stats: { checks: 'Cheklar', revenue: 'Tushum', shifts: 'Smenalar' },
    roles: { all: 'Hammasi', owner: 'Egasi', admin: 'Admin', seller: 'Sotuvchi' },
    form: {
      title: 'Yangi xodim',
      fullName: 'Ism va familiya',
      username: 'Login',
      password: 'Parol',
      role: 'Rol',
    },
  },
  permissions: {
    title: 'Ruxsatlar',
    profile: 'Ruxsat profili',
    preset: { trainee: 'Stajyor', seller: 'Sotuvchi', senior: 'Katta' },
    discountLimit: 'Chegirma limiti',
    debtLimit: 'Chekka qarz',
    noLimit: 'Limitsiz',
    customized: 'Qo‘lda sozlangan',
    roleDefault: 'Rol bo‘yicha standart',
    reset: 'Rol standartiga qaytarish',
    byRole: 'rol bo‘yicha',
    effectNote: 'O‘zgarishlar xodim keyingi kirishida kuchga kiradi.',
    savedNote: 'Saqlandi · keyingi kirishda kuchga kiradi.',
    risk: 'XAVF',
    capabilities: 'Nima qila oladi',
    noCapabilities: 'Faqat asosiy kirish',
    cap: {
      disc: 'chegirma {{value}}% gacha',
      discFree: 'chegirma cheksiz',
      debt: 'qarz {{value}}',
      debtFree: 'qarz cheksiz',
      price: 'narx o‘zgartiradi',
      ret: 'qaytarishlar',
      supply: 'qabul',
    },
    hint: {
      'sales.edit': 'Pozitsiya narxini o‘zgartirish — har bir o‘zgarish jurnalga tushadi',
      'sales.return': 'Qaytarishni administrator kodisiz mustaqil rasmiylashtirish',
      'sales.delete': 'O‘tkazilgan cheklarni o‘chirish',
      'debts.manage': 'Mijoz qarziga chek rasmiylashtirish va to‘lov qabul qilish',
      'zakup.accept': 'Tovar kirimini omborga tasdiqlash',
      'zakup.delete': 'Xaridlarni o‘chirish — ular bo‘yicha kirim bekor bo‘ladi',
      'products.delete': 'Katalogdan tovarlarni o‘chirish',
      'suppliers.delete': 'Yetkazuvchilarni o‘chirish',
      'customers.delete': 'Mijozlarni bazadan o‘chirish',
      'users.manage': 'Xodim yaratish va ularning kirishlarini o‘zgartirish',
      'cashregister.manage': 'Kassadan pul chiqarish (inkassatsiya)',
      'data.costPrice': 'Kelish narxi va tannarxni ko‘rish',
      'data.profit': 'Foyda va marjani ko‘rish',
      'data.auditLog': 'Xodimlar harakatlari jurnaliga kirish',
    },
    groups: {
      dashboard: 'Panel',
      sales: 'Sotuvlar',
      products: 'Tovarlar',
      categories: 'Kategoriyalar',
      zakup: 'Xarid',
      suppliers: 'Yetkazib beruvchilar',
      customers: 'Mijozlar',
      debts: 'Qarzlar',
      cashregister: 'Kassa',
      reports: 'Hisobotlar',
      users: 'Xodimlar',
      notifications: 'Bildirishnomalar',
      data: 'Ma’lumotlarga ruxsat',
    },
    perm: {
      'dashboard.access': 'Panelni ko‘rish',
      'notifications.access': 'Bildirishnomalarni ko‘rish',
      'products.access': 'Tovarlarni ko‘rish',
      'products.create': 'Tovar yaratish',
      'products.edit': 'Tovarni tahrirlash',
      'products.delete': 'Tovarni o‘chirish',
      'products.export': 'Tovarlarni eksport',
      'products.import': 'Tovarlarni import',
      'categories.access': 'Kategoriyalarni ko‘rish',
      'categories.manage': 'Kategoriyalarni boshqarish',
      'sales.access': 'Sotuvlarni ko‘rish',
      'sales.create': 'Sotuv yaratish',
      'sales.edit': 'Sotuvni tahrirlash',
      'sales.delete': 'Sotuvni bekor qilish',
      'sales.export': 'Sotuvlarni eksport',
      'sales.invoice': 'Fakturani chop etish',
      'sales.return': 'Qaytarishlarni rasmiylashtirish',
      'customers.access': 'Mijozlarni ko‘rish',
      'customers.manage': 'Mijozlarni boshqarish',
      'customers.delete': 'Mijozni o‘chirish',
      'customers.export': 'Mijozlarni eksport',
      'zakup.access': 'Xaridni ko‘rish',
      'zakup.create': 'Xarid yaratish',
      'zakup.accept': 'Yetkazishni qabul qilish',
      'zakup.delete': 'Xaridni o‘chirish',
      'suppliers.access': 'Yetkazuvchilarni ko‘rish',
      'suppliers.manage': 'Yetkazuvchilarni boshqarish',
      'suppliers.delete': 'Yetkazuvchini o‘chirish',
      'cashregister.access': 'Kassani ko‘rish',
      'cashregister.manage': 'Kassani boshqarish',
      'reports.access': 'Hisobotlarni ko‘rish',
      'reports.export': 'Hisobotlarni eksport',
      'users.access': 'Xodimlarni ko‘rish',
      'users.manage': 'Xodimlarni boshqarish',
      'users.shift': 'Smenalarni boshqarish',
      'debts.access': 'Qarzlarni ko‘rish',
      'debts.manage': 'Qarzlarni boshqarish',
      'debts.dueDate': 'Qarz muddatini o‘zgartirish',
      'data.costPrice': 'Kelish narxini ko‘rish',
      'data.profit': 'Foydani ko‘rish',
      'data.cashBalance': 'Kassa balansini ko‘rish',
      'data.allSalesView': 'Barcha sotuvlarni ko‘rish',
      'data.auditLog': 'Audit jurnalini ko‘rish',
    },
  },
  audit: {
    title: 'Audit jurnali',
    subtitle: 'Tizimda kim nima qilgani',
    tabs: { log: 'Jurnal', suspicious: 'Shubhali' },
    allActions: 'Barcha amallar',
    allUsers: 'Barcha foydalanuvchilar',
    empty: 'Yozuvlar yo‘q',
    cols: { time: 'VAQT', action: 'AMAL', user: 'FOYDALANUVCHI', entity: 'OB’EKT' },
    actions: {
      Create: 'Yaratish',
      Update: 'O‘zgartirish',
      Delete: 'O‘chirish',
      Cancel: 'Bekor qilish',
      Return: 'Qaytarish',
      Discount: 'Chegirma',
      MarkDebt: 'Qarzga',
      Payment: 'To‘lov',
      Withdraw: 'Yechish',
      Deposit: 'Kiritish',
      Open: 'Ochish',
      Close: 'Yopish',
      Block: 'Bloklash',
      Unblock: 'Blokdan chiqarish',
      Activate: 'Faollashtirish',
      Deactivate: 'Faolsizlantirish',
      PermissionChange: 'Ruxsat o‘zgarishi',
      PriceOverride: 'Narx o‘zgarishi',
      StockAdjust: 'Qoldiq tuzatish',
      Stocktake: 'Inventarizatsiya',
      Login: 'Kirish',
      LoginFailed: 'Muvaffaqiyatsiz kirish',
      Logout: 'Chiqish',
      PasswordChange: 'Parol almashtirish',
    },
    entities: {
      Sale: 'Sotuv',
      Product: 'Tovar',
      Customer: 'Mijoz',
      Supplier: 'Yetkazuvchi',
      User: 'Xodim',
      Debt: 'Qarz',
      Shift: 'Smena',
      CashRegister: 'Kassa',
      Market: 'Do‘kon',
      Auth: 'Avtorizatsiya',
    },
    suspicious: {
      clean: 'Hammasi toza — shubhali harakat yo‘q',
      failedLogins: 'Ko‘p marta muvaffaqiyatsiz kirish',
      bulkDelete: 'Ommaviy o‘chirish',
      errors: 'So‘nggi server xatolari',
      attempts: '{{count}} urinish',
      deletes: '{{count}} o‘chirish',
    },
  },
  account: {
    title: 'Mening hisobim',
    subtitle: 'Shaxsiy ma’lumotlar va kirish xavfsizligi',
    language: {
      title: 'Interfeys tili',
      subtitle: 'Darhol qo‘llanadi va hisobingizda saqlanadi',
      saveError: 'Til saqlanmadi — qayta urinib ko‘ring',
    },
    profile: 'Profil',
    fullName: 'Ism va familiya',
    phone: 'Telefon',
    telegram: 'Telegram',
    telegramSaved: 'Telegram saqlandi',
    openBot: 'Botni ochish',
    telegramLink: 'Telegram bot',
    telegramLinked: 'Bog‘langan',
    telegramUnlink: 'Uzish',
    telegramLinkAction: 'Bog‘lash',
    telegramLinkHint: 'Botga istalgan xabar yozing — u 6 xonali kod yuboradi. Kodni shu yerga kiriting (10 daqiqa amal qiladi).',
    telegramLinkDone: 'Telegram bog‘landi',
    login: 'Login',
    loginLocked: 'loginni o‘zgartirib bo‘lmaydi',
    nameLocked: 'ismni o‘zgartirish — administratorda',
    myResults: { title: 'Mening natijalarim · {{month}}', revenue: 'Sotuvlar', checks: 'Chek', avgCheck: 'O‘rtacha chek', shifts: 'Ishlangan smena' },
    password: {
      title: 'Parolni o‘zgartirish',
      hint: 'Kamida 8 belgi, harf va raqam',
      current: 'Joriy parol',
      new: 'Yangi parol',
      repeat: 'Parolni takrorlang',
      mismatch: 'Parollar mos kelmadi',
      change: 'Parolni o‘zgartirish',
      changed: 'Parol o‘zgartirildi',
    },
    notify: {
      title: 'Telegram bildirishnomalari',
      subtitle: 'Shaxsiy Telegram’ingizga nima yuborilsin',
      debt: 'Muddati o‘tgan qarzlar',
      stock: 'Tovar tugadi',
      shift: 'Smena yopilishi',
      noTelegram: 'Bildirishnoma olish uchun profilda Telegram’ni ko‘rsating.',
    },
    sessions: {
      title: 'Qurilmalar va sessiyalar',
      subtitle: 'Hisobingizga qayerdan kirilgan',
      thisDevice: 'shu qurilma',
      revoke: 'Yopish',
      revokeOthers: 'Boshqa barcha sessiyalarni yopish',
      empty: 'Faol sessiyalar yo‘q',
      now: 'hozir',
    },
    history: {
      clear: 'Tozalash',
      title: 'So‘nggi kirishlar',
      subtitle: 'Hisobga kirishlar tarixi',
      cols: { time: 'VAQT', device: 'QURILMA', status: 'HOLAT' },
      success: 'Muvaffaqiyatli',
      failed: 'Noto‘g‘ri parol',
      empty: 'Yozuvlar yo‘q',
    },
  },
  dashboard: {
    title: 'Egasi paneli',
    newSale: 'Yangi sotuv',
    shiftOpenAt: 'Smena ochiq · {{time}} dan',
    shiftClosed: 'Smena yopiq',
    stats: {
      salesToday: 'Bugungi sotuvlar',
      profitToday: 'Bugungi foyda',
      cashInRegister: 'Kassadagi naqd',
      customerDebts: 'Mijozlar qarzi',
      vsYesterday: 'kechagiga nisbatan',
      checksCount: '{{count}} chek',
      margin: 'marja {{value}}',
      withdrawalsToday: 'bugungi yechishlar: {{count}} · {{amount}} ga',
      noWithdrawals: 'bugun yechishlar yo‘q',
      overdueCount: '{{count}} ta muddati o‘tgan',
      totalCustomers: 'jami {{count}} mijoz',
      sellersOnShift: 'Smenadagi sotuvchilar',
      onShiftNow: 'hozir kassada: {{count}}',
      noOpenShift: 'ochiq smena yo‘q',
      stockSignals: 'Ombor signallari',
      outCount: '{{count}} ta tugagan',
      lowCount: '{{count}} ta tugayapti',
      stockOk: 'ombor normada',
    },
    chart: {
      title: 'Haftalik tushum',
      total: 'Jami',
    },
    recent: {
      title: 'So‘nggi sotuvlar',
      all: 'Barcha sotuvlar',
      empty: 'Hozircha sotuvlar yo‘q',
      openHint: 'Chekni ochish — o‘zgartirish, bekor qilish, qaytarish',
      cols: { time: 'VAQT', seller: 'SOTUVCHI', items: 'TOVARLAR', pay: 'TO‘LOV', sum: 'SUMMA' },
    },
    purchases: {
      title: 'Xaridlar',
      all: 'Barcha xaridlar',
      empty: 'Hozircha xaridlar yo‘q',
      inTransit: 'Yo‘lda',
      accepted: 'Qabul qilingan',
      positions: '{{count}} pozitsiya',
      accept: 'Qabul qilish',
    },
    sellerAccess: {
      title: 'Sotuvchilar ruxsati',
      configure: 'Sozlash',
      empty: 'Sotuvchilar qo‘shilmagan',
      active: 'Faol',
      blocked: 'Bloklangan',
    },
    attention: {
      title: 'E’tibor talab qiladi',
      open: { shift: 'smena sverkasini ochish', warehouse: 'omborni ochish', debt: 'qarzlarni ochish', supply: 'postavkani ochish', default: 'ochish' },
    },
    lowStock: {
      title: 'Omborda tugayapti',
      order: 'Xaridni rasmiylashtirish',
      empty: 'Hammasi yetarli',
    },
    payments: {
      title: 'Yaqin to‘lovlar',
      all: 'Barcha qarzlar',
      empty: 'Yaqin to‘lovlar yo‘q',
      due: '{{date}} gacha',
      today: 'bugun',
      inDays: '{{count}} kundan keyin',
      overdueDays: 'muddati {{count}} kun o‘tgan',
    },
    shift: {
      title: 'Smena · bugun',
      cashier: 'Kassir',
      openedAt: 'Ochilgan',
      checks: 'Cheklar',
      avgCheck: 'O‘rtacha chek',
      noShift: 'Smena ochilmagan',
    },
  },
  reports: {
    title: 'Hisobotlar',
    subtitle: 'Biznesning moliyaviy manzarasi',
    download: 'Hisobotni yuklab olish',
    period: { week: 'Hafta', month: 'Oy', quarter: 'Chorak' },
    stats: {
      revenue: 'Tushum',
      profit: 'Foyda',
      expenses: 'Xarid xarajatlari',
      avgCheck: 'O‘rtacha chek',
      vsPrevPeriod: 'oldingi davrga nisbatan',
      margin: 'marja {{value}}',
      purchCount: '{{count}} ta xarid',
      checksCount: '{{count}} chek',
      checksReturns: '{{count}} chek · qaytarish: {{returns}}',
    },
    chart: {
      title: 'Kunlar bo‘yicha tushum va foyda',
      revenue: 'Tushum',
      profit: 'Foyda',
      best: 'eng yaxshi',
    },
    categories: {
      title: 'Kategoriyalar bo‘yicha sotuvlar',
      empty: 'Davr uchun ma’lumot yo‘q',
    },
    payments: {
      title: 'To‘lov usullari',
      empty: 'Davr uchun ma’lumot yo‘q',
      debtRisk: 'Qarzga {{value}} — ulush yuqori. Qarz qaytishini kuzating.',
    },
    topProducts: {
      title: 'Top-5 tovar',
      empty: 'Davr uchun sotuvlar yo‘q',
      cols: { product: 'TOVAR', sold: 'SOTILGAN', revenue: 'TUSHUM' },
    },
    staff: {
      title: 'Sotuvchilar',
      empty: 'Davr uchun ma’lumot yo‘q',
      cols: { seller: 'SOTUVCHI', checks: 'CHEKLAR', revenue: 'TUSHUM', share: 'ULUSH' },
      checksAvg: '{{count}} chek · o‘rt. {{avg}}',
      shareNote: 'Davr tushumidagi ulush',
    },
  },
  labels: {
    popupBlocked: 'Brauzer chop etish oynasini bloklagan — fayl yuklab olindi. Qurilmalar bo‘limidan printerni sinab ko‘ring.',
    printFailed: 'Chop etish oynasini ochib bo‘lmadi. Brauzer sozlamalarini tekshiring.',
    title: 'Yorliq chop etish',
    subtitle: '{{count}} ta tovar',
    print: '{{count}} ta yorliq chop etish',
    pcs: 'dona',
    size: 'O‘lcham',
    mm: 'mm',
    sizeFromSettings: '— Sozlamalardagi rulon',
    previewCaption: 'Ko‘rinish — chop etilganda shunday chiqadi ({{w}}×{{h}} mm)',
    previewFailed: 'Ko‘rinishni chizib bo‘lmadi',
    willGenerate: 'kod yaratiladi',
    generateNote: '{{count}} ta tovarda shtrix-kod yo‘q — chop etishdan oldin avtomatik yaratiladi.',
    printerHint:
      'Chop etish oynasida printer yorliq ruloniga sozlangan bo‘lsin (o‘lcham va masshtab «100%»). A4 ga sozlangan printer yorliqni varaq burchagida kichkina qilib bosadi.',
    fromProduct: 'Yorliq chop etish',
    selected: '{{count}} ta tanlandi',
    selectAll: 'Sahifadagi hammasini tanlash',
    clearSelection: 'Bekor qilish',
    afterAccept: 'Qabul qilindi. Yorliq chop etilsinmi?',
    later: 'Keyinroq',
  },
  pos: {
    title: 'Yangi sotuv',
    creditApplied: 'Mijoz avansidan hisobga olindi',
    back: 'Sotuvlarga',
    park: 'Keyinga qoldirish',
    held: 'Kutayotgan cheklar',
    leaveTitle: 'Savdo tugallanmagan',
    leaveMessage:
      'Chekni keyinga qoldirasizmi? U «Kutayotgan cheklar» ro‘yxatida saqlanadi va istalgan vaqtda davom ettirasiz.',
    stay: 'Kassada qolish',
    discard: 'Chekni o‘chirish',
    discardConfirm: 'Yakunlanmagan chek o‘chirilsinmi? Tovarlar omborga qaytadi.',
    searchPlaceholder: 'Shtrix-kodni skanerlang yoki nomi bo‘yicha qidiring…',
    scan: {
      notFound: '{{code}} — bu shtrix-kod bo‘yicha tovar topilmadi',
    },
    emptyCart: 'Savat bo‘sh — sotuvni boshlash uchun tovar toping',
    cols: {
      product: 'TOVAR',
      qty: 'SONI',
      price: 'NARX',
      subtotal: 'SUMMA',
    },
    quantity: 'Soni',
    price: 'Narx',
    subtotal: 'Summa',
    discount: 'Chegirma',
    remove: 'Olib tashlash',
    customer: {
      label: 'Mijoz',
      walkIn: 'Chakana',
      add: 'Mijoz qo‘shish',
      searchPlaceholder: 'Mijozni ismi yoki telefoni bo‘yicha qidiring…',
    },
    total: 'Jami',
    amount: 'To‘lovga summa',
    mix: {
      rest: 'qoldiq',
      remainder: 'Qoldiq',
    },
    done: {
      title: 'Sotuv rasmiylashtirildi',
      print: 'Chek chiqarish',
      finish: 'Tugatish',
      receipt: 'Chek',
      shift: 'Smena',
      thanks: 'Xaridingiz uchun rahmat!',
      printProblem: 'Chek chiqmadi:',
      printFailed: 'printerga ulanib bo‘lmadi.',
    },
    payment: {
      title: 'To‘lov usuli',
      cash: 'Naqd',
      card: 'Karta',
      transfer: 'O‘tkazma',
      click: 'Click',
      debt: 'Qarzga',
      mixed: 'Miks',
    },
    dueDate: 'Qaytarish muddati',
    checkout: 'Sotuvni rasmiylashtirish',
    success: 'Sotuv rasmiylashtirildi',
  },
  landing: {
    nav: {
      login: 'Kirish',
    },
    hero: {
      eyebrow: 'Qurilish biznesi uchun ERP',
      title: 'Qurilish do‘koningizda tartib o‘rnating',
      subtitle:
        'Sotuv, ombor, mijoz qarzlari va hisobot — bitta tizimda. 6 ta modul, 3 ta rol: egasi, administrator va sotuvchi.',
      // Raqamlar mahsulotdagi haqiqiy qiymatlar: 15 soniya — «Sotuv va kassa»
      // bo'limidagi da'vo bilan bir xil; 21:00 — Telegram kunlik xulosasining
      // standart vaqti (TELEGRAM_DAILY_SUMMARY_HOUR).
      bullets: {
        b1: 'Sotuv — 15 soniyada',
        b2: 'Qoldiq — har chekdan keyin darhol',
        b3: 'Kunlik hisobot — 21:00 da Telegram’ga',
      },
    },
    modules: {
      eyebrow: 'Ichida nima bor',
      title: 'Olti modul — butun do‘kon',
      sales: {
        title: 'Sotuv va kassa',
        desc: 'Sotuv soniyalarda rasmiylashtiriladi — kassada navbat yig‘ilmaydi. Smenalar va naqd pul nazoratda.',
      },
      warehouse: {
        title: 'Ombor hisobi',
        desc: 'Tovar qoldiqlari real vaqtda — sementdan armaturagacha, istalgan o‘lchov birligida.',
      },
      debts: {
        title: 'Mijoz qarzlari',
        desc: 'Har bir qarz qayd etilgan: kim, qancha va qachon qaytarishni va’da qilgan.',
      },
      purchases: {
        title: 'Xarid va yetkazuvchilar',
        desc: 'Tovar kirimi, yetkazuvchilar va xarid narxlari — bitta jurnalda.',
      },
      employees: {
        title: 'Xodimlar va huquqlar',
        desc: 'Egasi, administrator va sotuvchilar — har birida o‘z huquqlari va ish smenalari.',
      },
      reports: {
        title: 'Hisobot va tahlil',
        desc: 'Tushum, foyda va tovar harakati — bir bosishda tayyor hisobot, qo‘lda hisoblashsiz.',
      },
    },
    cta: {
      eyebrow: 'Ariza',
      title: 'Ariza qoldirish',
      subtitle:
        'Sotuv — soniyalarda, hisobot — bir bosishda. Ism va telefonni qoldiring, administrator siz bilan bog‘lanadi.',
      nameLabel: 'Ism',
      namePlaceholder: 'Ismingizni kiriting',
      phoneLabel: 'Telefon',
      phonePlaceholder: '+998 __ ___ __ __',
      submit: 'Ariza qoldirish',
      success: 'Ariza yuborildi — tez orada bog‘lanamiz',
      privacy: 'Ma’lumotlar faqat siz bilan bog‘lanish uchun ishlatiladi',
    },
    footer: {
      privacy: 'Maxfiylik siyosati',
      tagline: 'Qurilish biznesi uchun ERP',
    },
  },
  placeholder: {
    soon: 'Bo‘lim ishlab chiqilmoqda',
  },
  // SuperAdmin konsoli — maketlar faqat ruscha, shuning uchun birinchi
  // bosqichda mazmun ham ruscha (TZ §A4); kalitlar tayyor.
  sa: {
    nav: {
      dashboard: 'Panel',
      requests: 'Arizalar',
      stores: 'Do‘konlar',
      billing: 'Obuna va to‘lovlar',
      users: 'Foydalanuvchilar',
      settings: 'Sozlamalar',
    },
    auth: {
      title: 'Platforma konsoli',
      subtitle: 'Faqat Buildix administratori uchun.',
      notSuperAdmin: 'Bu sahifa faqat platforma administratori uchun.',
    },
    placeholder: {
      title: 'Bo‘lim tayyorlanmoqda',
      body: 'Konsol qobig‘i ishlayapti: navigatsiya, tema va kirish nazorati. Bu ekran mazmuni {{phase}} bosqichida qo‘shiladi.',
    },
    dashboard: {
      title: 'Buildix paneli',
      subtitle: 'platformadagi barcha do‘konlar',
      kpi: {
        activeStores: 'Faol do‘konlar',
        newThisMonth: 'shu oyda +{{count}}',
        newRequests: 'Yangi arizalar',
        fromWelcome: 'welcome-sahifadan',
        revenue: 'Obuna daromadi',
        revenueSoon: 'tariflar bilan birga paydo bo‘ladi',
        perMonth: 'so‘m/oy',
        overdue: 'To‘lov kechikkan',
        overdueHint: 'to‘lovni eslating',
      },
      systemsOk: 'Barcha tizimlar ishlayapti',
      systemsDown: 'Server bilan aloqa yo‘q',
      acceptedHint: 'qabul qilindi — mijoz bilan bog‘laning',
      rejectedHint: 'rad etildi',
      requestsTitle: 'Ulanish arizalari',
      viewAll: 'barcha arizalar',
      noRequests: 'Yangi ariza yo‘q',
      attentionTitle: 'E’tibor talab qiladi',
      allGood: 'Hammasi joyida',
      overdueLine: '«{{name}}» — to‘lov {{days}} kun kechikdi',
      overdueHelp: 'egasiga qo‘ng‘iroq qiling yoki kirishni cheklang',
      expiringLine: 'Shu haftada tugaydigan obunalar: {{count}}',
      storesTitle: 'Do‘konlar',
      byLastActivity: 'oxirgi faollik',
    },
    store: {
      status: { active: 'Faol', overdue: 'Kechikkan', blocked: 'Bloklangan' },
      paidUntil: '{{date}} gacha',
      noExpiry: 'muddatsiz',
      users: '{{count}} foyd.',
      block: 'Bloklash',
      unblock: 'Yoqish',
      blockedByOperator: 'Platforma operatori bloklagan',
      since: '{{date}} dan',
      ownerTitle: 'Egasi',
      owner: 'Ismi',
      phone: 'Telefon',
      subscriptionTitle: 'Obuna',
      plan: 'Tarif',
      planSoon: 'S3 da paydo bo‘ladi',
      paidUntilLabel: 'To‘langan',
      statsTitle: 'Faollik',
      usersLabel: 'Foydalanuvchilar',
      checksThisMonth: 'Shu oydagi cheklar',
      lastActivity: 'Oxirgi faollik',
      outstandingDebt: 'Mijozlar qarzi',
      paymentsTitle: 'To‘lovlar tarixi',
      paymentsSoon: 'Obuna va to‘lovlar bilan birga paydo bo‘ladi.',
      blockedReason: 'Blok sababi',
      blockWarning: 'Blok do‘konning BARCHA foydalanuvchilari uchun kirishni darhol yopadi. Ma’lumotlar saqlanadi.',
      blockFull: 'Do‘konni bloklash',
      unblockFull: 'Do‘konni yoqish',
    },
    requests: {
      title: 'Ulanish arizalari',
      subtitle: 'welcome-sahifada to‘ldiriladi (ism + telefon)',
      tabs: { new: 'Yangi', accepted: 'Qabul qilingan', rejected: 'Rad etilgan', all: 'Hammasi' },
      col: { applicant: 'Arizachi', phone: 'Telefon', received: 'Kelgan', status: 'Holat' },
      status: {
        new: 'Yangi',
        accepted: 'Qabul qilindi',
        connected: 'Ulandi',
        rejected: 'Rad etildi',
      },
      searchPlaceholder: 'Ism yoki telefon…',
      empty: 'Bu toifada ariza yo‘q',
      call: 'Qo‘ng‘iroq qilish',
      accept: 'Qabul qilish',
      reject: 'Rad etish',
      reopen: 'Qaytarish',
      createStore: 'Do‘kon yaratish',
      storeCreated: 'do‘kon yaratildi',
      rejectedByOperator: 'Operator rad etdi',
      workflowHint:
        'Tartib: arizachiga qo‘ng‘iroq qiling → «Qabul qilish» → «Do‘kon yaratish» — do‘kon va egasi akkaunti yaratiladi. Manzil va loginni SMS bilan yuborish mumkin, parolni shaxsan bering.',
    },
    create: {
      title: 'Do‘kon yaratish',
      storeName: 'Do‘kon nomi',
      ownerName: 'Egasining ismi',
      ownerPhone: 'Telefon',
      standaloneHint: 'Arizasiz yangi do‘kon ochish',
      newStore: 'Do‘kon yaratish',
      address: 'Do‘kon manzili',
      addressHint: 'nomdan yasaladi — egasi va xodimlari shu manzil orqali kiradi',
      username: 'Egasining logini',
      password: 'Parol',
      generate: 'Yaratish',
      period: 'To‘langan muddat',
      months: '{{count}} oy',
      paidUntil: 'To‘langan:',
      free: 'bo‘sh',
      taken: 'band',
      submit: 'Do‘kon yaratish',
      passwordWarning:
        'Parol BIR marta ko‘rsatiladi va hech qayerda saqlanmaydi. Hozir nusxalab, egasiga shaxsan bering — SMS orqali parol yuborilmaydi.',
      doneTitle: 'Do‘kon yaratildi',
      doneBody:
        'Egasiga manzil va loginni bering. Parolni hozir nusxalang — oyna yopilgach uni tiklab bo‘lmaydi, faqat qayta yaratish mumkin.',
    },
    stores: {
      title: 'Do‘konlar',
      subtitle: 'barcha do‘konlar, tariflar va holat',
      summary: '{{total}} ta do‘kon · faol: {{active}} · kechikkan: {{overdue}} · bloklangan: {{blocked}}',
      filters: { all: 'Hammasi', active: 'Faol', overdue: 'Kechikkan', blocked: 'Bloklangan' },
      col: {
        store: 'Do‘kon',
        owner: 'Egasi',
        plan: 'Tarif',
        paidUntil: 'To‘langan',
        users: 'Foyd.',
        status: 'Holat',
      },
      searchPlaceholder: 'Nomi, egasi yoki shahar…',
      empty: 'Hech narsa topilmadi',
    },
    billing: {
      title: 'Obuna va to‘lovlar',
      subtitle: 'tariflar, to‘lovlar va kechikishlar',
      summary: 'oyiga kutilmoqda: {{expected}} so‘m · kechikkan: {{overdue}} so‘m',
      tabs: { all: 'Hammasi', soon: 'Muddati yaqin', overdue: 'Kechikkan' },
      status: { paid: 'To‘langan', soon: 'Muddati yaqin', overdue: 'Kechikkan' },
      plans: { Start: 'Start', Standard: 'Standart', Pro: 'Pro' },
      planStores: '{{count}} ta do‘kon',
      planLimits: '{{points}} nuqtagacha · foydalanuvchilar: {{users}}',
      unlimited: 'limitsiz',
      channels: { Cash: 'Naqd', Click: 'Click', Payme: 'Payme', Transfer: 'O‘tkazma' },
      col: { amount: 'Summa/oy' },
      lastPayment: 'oxirgi to‘lov: {{date}} · {{channel}}',
      noPayments: 'hali to‘lov bo‘lmagan',
      searchPlaceholder: 'Do‘kon…',
      payAction: 'To‘lov qabul qilindi',
      payTitle: 'To‘lov qabul qilindi',
      payConfirm: 'To‘lovni yozish',
      period: 'Muddat',
      channel: 'To‘lov usuli',
      amount: 'Yoziladigan summa',
      note: 'Izoh',
      notePlaceholder: 'ixtiyoriy — kvitansiya raqami va h.k.',
      anchorOnExpiry: 'Eski sanadan uzaytirildi — hisob kuni surilmaydi.',
      anchorOnToday: 'Otsrochka tugab, kirish yopilgan edi — bugundan hisoblanadi.',
      anchorManual: 'Muddat qo‘lda kiritildi.',
      customMonths: 'yoki',
      customDate: 'Sana',
      autoDate: 'avtomatik',
      remindAll: 'Qarzdorlarga eslatish',
      remindResult: 'yetib bordi: {{sent}} · Telegramsiz: {{unreachable}}',
      noTelegram: 'Telegram yo‘q',
      noTelegramHint: 'Ega Telegramni bog‘lamagan — eslatma yetib bormaydi, unga qo‘ng‘iroq qiling.',
      recentTitle: 'Oxirgi to‘lovlar',
      noPaymentsYet: 'Hali to‘lov yo‘q',
    },
    users: {
      title: 'Platforma foydalanuvchilari',
      subtitle: 'barcha do‘konlardagi xodimlar',
      summary: '{{total}} foydalanuvchi · egalar: {{owners}} · adminlar: {{admins}} · sotuvchilar: {{sellers}} (shu sahifada)',
      roles: { Owner: 'Egasi', Admin: 'Admin', Seller: 'Sotuvchi' },
      col: { user: 'Foydalanuvchi', role: 'Rol', store: 'Do‘kon', lastLogin: 'Oxirgi kirish' },
      searchPlaceholder: 'Ism, login yoki telefon…',
      allStores: 'Barcha do‘konlar',
      resetPassword: 'Parolni almashtirish',
      resetTitle: 'Yangi parol',
      resetConfirm: 'Parolni o‘rnatish',
      resetWarning: 'Eski parol shu zahoti ishlamay qoladi va foydalanuvchining barcha sessiyalari yopiladi. Yangi parolni shaxsan bering — SMS orqali yuborilmaydi.',
      resetDone: 'Parol o‘zgartirildi',
      resetDoneBody: 'Parolni hozir nusxalang — oyna yopilgach uni tiklab bo‘lmaydi, faqat qayta almashtirish mumkin.',
      scopeHint: 'Superadmin faqat platformaga kirishni boshqaradi: parol va blok. Do‘kon ichidagi rollar va ruxsatlarni egasi yoki admini sozlaydi.',
    },
    settings: {
      title: 'Platforma sozlamalari',
      subtitle: 'tarif, to‘lov, SMS va blok qoidalari — barcha do‘konlar uchun',
      saved: 'Sozlamalar saqlandi',
      plansTitle: 'Tariflar',
      plansHint: 'oylik narx (so‘m) — keyingi to‘lovdan qo‘llanadi',
      notifyTitle: 'Do‘konlarga bildirishnoma (Telegram)',
      notifyHint: 'do‘kon egasiga Telegram orqali yuboriladi. SMS ishlatilmaydi — xabar bepul, yetib borgani tasdiqlanadi va ega o‘sha yerdan hisobot ham so‘ray oladi.',
      notifyExpiring: 'Obuna tugashi yaqin',
      notifyExpiringSub: 'tugashiga {{count}} kun qolganda',
      expiryReminderDays: 'Necha kun oldin eslatilsin',
      notifyBlocked: 'Do‘kon bloklandi',
      notifyBlockedSub: 'blok qilingan zahoti — sababi bilan',
      blockTitle: 'Blok qoidalari',
      blockHint: 'to‘lov kechikkanda nima bo‘ladi',
      graceDays: 'Obuna tugagach otsrochka (kun)',
      warnOnOverdue: 'Interfeysda ogohlantirish',
      warnOnOverdueSub: 'kechikishning 1-kunidan egaga va adminga sariq plashka',
      restrictAfterGrace: '«Faqat ko‘rish» rejimi',
      restrictAfterGraceSub: 'otsrochkadan keyin: sotuv va zakup qabuli bloklanadi, ma’lumot ko‘rinadi',
      fullBlockAfterDays: 'To‘liq blok (kun)',
      fullBlockAfterDaysSub: '0 — kirish hech qachon yopilmaydi',
      supportTitle: 'Qo‘llab-quvvatlash kontaktlari',
      supportHint: 'kirish sahifasida ko‘rsatiladi',
      supportPhone: 'Telefon',
      supportTelegram: 'Telegram',
      supportEmail: 'E-mail',
      applyHint: 'Blok qoidalari saqlangan zahoti kuchga kiradi.',
    },
  },
};
